import React, { Component } from 'react'
import { autorun } from 'mobx'
import { inject, observer } from 'mobx-react'
import NotificationSystem from 'react-notification-system'

const NotificationManager = inject('notificationStore')(
  observer(
    class NotificationManager extends Component {
      constructor (props) {
        super(props)
        this.myRef = React.createRef()
        this.mobxHook = autorun(() => {
          if (this.props.notificationStore.notificationData.message !== null) {
            this.myRef.current.addNotification(
              this.props.notificationStore.notificationData
            )
          }
        })
      }

      render () {
        return (
          <NotificationSystem ref={this.myRef} />
        )
      }
    }
  )
)

export default NotificationManager



// WEBPACK FOOTER //
// ./src/components/NotificationManager.js